import React from 'react';

import TopStub from './TopStub';
import BottomStub from './BottomStub';

class MaterialListItemStub extends React.PureComponent {
  render() {
    return (
      <div style={{ width: '144px', marginBottom: '20px' }}>
        <TopStub />

        <BottomStub />
      </div>
    );
  }
}

export default MaterialListItemStub;
